/* La Bascule : rendu 3D plus lisible (motifs visibles sous tous les angles) */
(function () {
  'use strict';
  var B = window.Bascule;
  if (!B || !B.Viewer || B.Viewer.prototype._rendu) return;
  var P = B.Viewer.prototype, oInit = P.init, oAdd = P._addCovers, oDraw = P.draw;

  function prepMesh(o) { if (o.isMesh) { o.castShadow = true; o.receiveShadow = true; } }

  function enhance(view) {
    var v = view.v; if (!v) return;
    var T = v.T;
    // Ombres : les rainures se creusent visuellement, quel que soit l'angle de vue
    v.r.shadowMap.enabled = true;
    v.r.shadowMap.type = T.PCFSoftShadowMap;
    v.key.castShadow = true;
    v.key.shadow.mapSize.set(2048, 2048);
    var c = v.key.shadow.camera;
    c.left = -110; c.right = 110; c.top = 110; c.bottom = -110; c.near = 40; c.far = 520;
    c.updateProjectionMatrix();
    v.key.shadow.bias = -0.0004;
    v.key.shadow.normalBias = 0.03;
    v.key.shadow.radius = 2.5;
    // Une lumière rasante en plus, qui accroche le relief du motif
    var graze = new T.DirectionalLight(0xfff6ea, 0.42);
    graze.position.set(160, 40, 60);
    v.scene.add(graze);
    v.graze = graze;
    // Parois des rainures nettes, et chaque face dessinée des deux côtés
    [v.coverMat, v.leverMat].forEach(function (m) {
      m.flatShading = true;
      m.side = T.DoubleSide;
      m.shadowSide = T.FrontSide;
      m.roughness = 0.88;
      m.needsUpdate = true;
    });
    v.piece.traverse(prepMesh);
    v.before.traverse(prepMesh);
    v._rendu = true;
    view.frame();
  }

  P.init = function () {
    oInit.apply(this, arguments);
    try { enhance(this); } catch (e) { console.error(e); }
  };
  P._addCovers = function (M) {
    oAdd.call(this, M);
    if (this.v && this.v._rendu) this.v.piece.traverse(prepMesh);
  };
  P.draw = function () {
    var v = this.v;
    if (!v || !v._rendu) return oDraw.apply(this, arguments);
    var r = v.r, render = r.render;
    r.render = function () {};
    try { oDraw.apply(this, arguments); } finally { r.render = render; }
    // Moins de lumière d'ambiance, plus de contraste dans le relief
    var n = v.nNow, L = function (a, b) { return a + (b - a) * n; };
    v.hemi.intensity = L(0.34, 0.13);
    v.key.intensity = L(1.0, 0.38);
    v.fill.intensity = L(0.16, 0.03);
    if (v.graze) v.graze.intensity = L(0.42, 0.08);
    r.render(v.scene, v.cam);
  };
  P._rendu = true;
})();

/* La Bascule : guide de mesure, l'épaisseur se mesure touche comprise (plaque + interrupteur) */
(function () {
  'use strict';
  var B = window.Bascule;
  if (!B || !B.Guide || B.Guide.prototype._epaisseur) return;
  var P = B.Guide.prototype, oBuild = P.build, oDraw = P.draw;
  var KEY = 3; // relief de la touche devant la plaque, en mm (modèle du guide)
  var NAVY = 0x1A1E50, MAND = 0xF58334;
  var CAM_T = [-0.72, 0.42, 0.9];
  function num(v) { return (Math.round(v * 100) / 100).toString().replace('.', ','); }
  function ss(a, b, x) { var u = Math.min(1, Math.max(0, (x - a) / (b - a))); return u * u * (3 - 2 * u); }
  function drop(dyn, o) {
    if (!o) return;
    dyn.remove(o);
    if (o.geometry) o.geometry.dispose();
    if (o.material) { if (o.material.map) o.material.map.dispose(); o.material.dispose(); }
  }

  P.build = function () {
    oBuild.apply(this, arguments);
    var g = this.g; if (!g || !g.A) return;
    var T = g.T, d = g.d, A = g.A, dyn = g.dyn, W = d.w, H = d.h, Th = d.t, tot = Th + KEY;
    var ry = H / 2 - 22; // bas de la règle : elle longe le haut du côté gauche de la plaque
    var sx = -W / 2 - 1.2; // flanc gauche réel de la plaque (bord arrondi de 1,2 mm compris)
    var kw = Math.min(d.double ? 87 : W, 87) * 0.46;
    var x0 = d.double ? -(d.e || 0) / 2 : 0;
    drop(dyn, A.tLab); drop(dyn, A.tM);
    // Règle perpendiculaire au mur, contre le côté gauche de la plaque, graduations vers l'extérieur
    g.ruler2.mesh.setRotationFromMatrix(new T.Matrix4().makeBasis(new T.Vector3(0, 0, 1), new T.Vector3(0, 1, 0), new T.Vector3(-1, 0, 0)));
    // Une carte posée à plat sur la touche, jusqu'à la règle
    var xL = sx, xR = x0 + kw / 2 + 12;
    var cy0 = 14, cy1 = ry + 18;
    var card = new T.Mesh(new T.BoxGeometry(xR - xL, cy1 - cy0, 0.8), new T.MeshStandardMaterial({ color: NAVY, roughness: 0.6, transparent: true, opacity: 0 }));
    card.castShadow = true; card.position.set((xL + xR) / 2, (cy0 + cy1) / 2, tot + 0.4); dyn.add(card);
    var mark = new T.Mesh(new T.BoxGeometry(0.4, 22, 0.9), new T.MeshBasicMaterial({ color: MAND, transparent: true, opacity: 0, depthTest: false }));
    mark.renderOrder = 9; mark.position.set(sx - 1.45, ry + 10, tot); dyn.add(mark);
    var read = this.label(num(tot / 10), { bg: '#F58334', size: 5.5 }); read.position.set(sx - 3, ry + 27, tot); dyn.add(read);
    var lab = this.label('Épaisseur totale ' + num(tot) + ' mm'); lab.position.set(-W / 2 + 6, -H / 2 + 2, tot + 6); dyn.add(lab);
    var sub = this.label('touche comprise', { bg: '#F0BF3C', fg: '#1A1E50', size: 5 }); sub.position.set(-W / 2 + 6, -H / 2 - 6.5, tot + 6); dyn.add(sub);
    g.ry = ry; g.sx = sx;
    A.tCard = card; A.tM = mark; A.tR = read; A.tLab = lab; A.tSub = sub;
    g.tot = tot;
  };

  P.draw = function () {
    var g = this.g;
    if (!g || !g.A || g.tot == null) return oDraw.apply(this, arguments);
    var r = g.r, render = r.render;
    r.render = function () {};
    try { oDraw.apply(this, arguments); } finally { r.render = render; }
    var d = g.d, A = g.A, W = d.w, H = d.h, Th = d.t, tot = g.tot;
    var pi = Math.min(g.ph.length - 1, Math.floor(g.t / 5)), ph = g.ph[pi], u = g.t - pi * 5;
    var prevPh = g.ph[(pi + g.ph.length - 1) % g.ph.length];
    var fade = function (a, b, c, e) { return ss(a, b, u) * (1 - ss(c, e, u)); };
    var op = function (o, val) { if (!o || !o.material) return; o.material.opacity = val; o.visible = val > 0.01; };
    var isT = ph === 't';
    // Règle : arrive contre le côté de la plaque, le bout contre le mur
    if (isT) g.ruler2.mesh.position.set(g.sx, g.ry, (1 - ss(1.0, 2.2, u)) * 40);
    // Carte : vient se plaquer sur la touche
    A.tCard.position.z = tot + 0.4 + (isT ? (1 - ss(2.3, 3.1, u)) * 26 : 0);
    op(A.tCard, isT ? fade(2.3, 2.8, 4.4, 4.9) : 0);
    op(A.tM, isT ? fade(3.0, 3.3, 4.4, 4.9) : 0);
    op(A.tR, isT ? fade(3.1, 3.5, 4.4, 4.9) : 0);
    op(A.tLab, isT ? fade(3.4, 3.9, 4.5, 5.0) : 0);
    op(A.tSub, isT ? fade(3.6, 4.0, 4.5, 5.0) : 0);
    // Caméra plus de profil pour voir le relief de la touche
    if (isT || prevPh === 't') {
      var CAM = { w: [-0.22, 0.1, 1.0], h: [-0.22, 0.1, 1.0], e: [-0.2, 0.14, 0.9], t: CAM_T, c: [-0.48, 0.24, 1.0] };
      var prev = CAM[prevPh], cur = CAM[ph];
      var k = prev.map(function (val, i) { return val + (cur[i] - val) * ss(0, 1.0, u); });
      var span = Math.max(W, H) + 56;
      var dist = (span * 0.5) / Math.tan((g.cam.fov * Math.PI) / 360) * 1.25 * k[2] / Math.min(1, g.cam.aspect * 0.95);
      var cp = Math.cos(k[1]), tz = Th / 2;
      g.cam.position.set(Math.sin(k[0]) * cp * dist, Math.sin(k[1]) * dist, tz + Math.cos(k[0]) * cp * dist);
      g.cam.lookAt(0, 0, tz);
    }
    r.render(g.scene, g.cam);
  };
  P._epaisseur = true;
})();
